<template>
  <div>
    <!-- <drag :isPublic="false" :selectList="selectList" @dropEnd="dropEnd" /> -->
    <el-table ref="multipleTable" border :data="selectList" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" :expand-row-keys="expandRowKeys" row-key="name">
      <!-- <el-table-column type="selection" width="55"></el-table-column> -->
      <el-table-column label="客户姓名">
        <template slot-scope="scope">
          <span>{{ scope.row.remark }}</span>
        </template>
      </el-table-column>
      <el-table-column label="照片数" width="90px">
        <template slot-scope="scope">
          <span>{{ scope.row.images.length }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="操作" width="90">
        <template slot-scope="scope">
          <span class="table_btn" @click="fold(scope)">
            <i :class="expandRowKeys.indexOf(scope.row.name) === -1 ? 'el-icon-arrow-right' : 'el-icon-arrow-down'"></i> {{ expandRowKeys.indexOf(scope.row.name) === -1 ? '展开' : '隐藏' }} </span>
        </template>
      </el-table-column>
      <el-table-column type="expand" width="1">
        <template slot="header">
          <span class="btn_del" @click="clickDelete()">批量删除</span>
        </template>
        <template slot-scope="scope">
          <div class="img_box">
            <div class="single_img_box" v-for="(img, index) in scope.row.images" :key="index">
              <div class="img">
                <el-image :src="img.smallSrc" :preview-src-list="getImgList(scope.row.images, index)" fit="cover"></el-image>
              </div>
              <!-- <div class="del" @click="deleteImg(scope,img,index)">{{img.isNew?'移除':''}}</div> -->
            </div>
          </div>
        </template>
      </el-table-column>
      <input type="file" ref="addImgInput" multiple accept="image/jpeg" @change="addImg" style="display:none;">
    </el-table>
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="30%">
      <span>确认删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteUser()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="修改客户名称" :visible.sync="changeDialog" width="30%">
      <el-input v-model="changeItem.remark" placeholder="请输入内容"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeDialog = false">取 消</el-button>
        <el-button type="primary" @click="changeUserName">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { resizeImage } from '@/utils/transitionFile.js'
// import ExifReader from 'exifreader'
// import drag from './drag.vue'
export default {
  components: {
    // drag
  },
  data () {
    return {
      changeItem: {},
      changeDialog: false,
      expandRowKeys: [],
      deleteDialog: false,
      selectList: [],
      selected: [],
      addUser: null
    }
  },
  methods: {
    changeUserName () {
      console.log(this.selectList, this.changeItem)
      this.selectList.forEach(item => {
        if (item.name === this.changeItem.name) {
          item.name = this.changeItem.remark
          item.remark = this.changeItem.remark
          item.userName = this.changeItem.remark
        }
      })
      this.changeDialog = false
    },
    fold (scope) {
      if (this.expandRowKeys.indexOf(scope.row.name) !== -1) {
        this.expandRowKeys.splice(this.expandRowKeys.indexOf(scope.row.name), 1)
      } else {
        this.expandRowKeys.push(scope.row.name)
      }
    },
    getImgList (images, index) {
      console.log(111)
      let list = images.reduce((list, item) => {
        list.push(item.src)
        return list
      }, [])
      return list.slice(index).concat(list.slice(0, index))
    },
    clickDelete () {
      if (this.selected.length === 0) {
        this.$notify({
          title: '警告',
          message: '请选择客户',
          type: 'error'
        })
        this.deleteDialog = false
      } else { this.deleteDialog = true }
    },
    init (data) {
      console.log(data)
      this.selectList = data
    },
    deleteImg (scope, img, index) {
      if (img.isNew) {
        scope.row.images.splice(index, 1)
      }
    },
    addImg (data) {
      if (data.target.files.length === 0) {
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '正在上传图片',
        spTEXT: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let num = 0
      let _this = this
      let files = data.target.files

      files.forEach(item => {
        let url = window.URL.createObjectURL(item)

        resizeImage(url, (val) => {
          _this.selectList[_this.addUser.$index].images.push({
            isNew: true,
            src: url,
            imgDetail: {},
            smallSrc: val,
            file: item,
            name: item.name.slice(0, item.name.indexOf('.')),
            uploadedSrc: ''
          })
          num++
          if (num === files.length) {
            loading.close()
          }
        }, 105, 105)
      })
    },
    selectImg (scope) {
      this.addUser = scope
      this.$refs.addImgInput.click()
    },
    deleteUser () {
      if (
        this.selected.some(item => {
          return !item.isNew
        })
      ) {
        this.$notify({
          title: '警告',
          message: '老客户图片无法删除',
          type: 'error'
        })
        return false
      }
      this.selectList = this.selectList.filter(user => {
        let lock = true
        this.selected.forEach(item => {
          if (item.name === user.name) {
            lock = false
          }
        })
        return lock
      })
      this.deleteDialog = false
    },
    handleSelectionChange (val) {
      this.selected = val
    },
    getList () {
      return this.selectList
    },
    dropEnd (val) {
      this.selectList.push(val)
    }
  }
}
</script>

<style lang="less" scoped>
@deep: ~">>>";

.color_blue {
  font-size: 14px;
  font-family: Source Han Sans CN, Source Han Sans CN-Light;
  font-weight: 300;
  color: #1473e6;
  cursor: pointer;
}

.btn_del {
  display: block;
  height: 27px;
  text-align: center;
  background: #ffffff;
  border: 1px solid #6d6d6d;
  border-radius: 27px;
  cursor: pointer;
}

.function {
  display: flex;
  justify-content: flex-end;
  line-height: 27px;
  margin: 27px 0 10px;

  .btn_white {
    width: 97px;
    height: 27px;
    background: #ffffff;
    border: 1px solid #6d6d6d;
    border-radius: 27px;
    line-height: 27px;
    text-align: center;
    margin-left: 20px;
  }
}

.img_box {
  // background-color: #f2f2f2;
  padding: 43px 64px;
  display: flex;
  flex-wrap: wrap;

  .single_img_box {
    width: 106px;
    height: 106px;
    display: flex;
    flex-direction: column;
    border-radius: 7px;
    overflow: hidden;
    border: 1px solid #6d6d6d;
    margin-bottom: 10px;
    margin-right: 14px;

    &:nth-child(6n) {
      margin-right: 0;
    }

    .img {
      flex: 1;
      overflow: hidden;

      @{deep} .el-image {
        width: 100%;
        height: 106px;

        img {
          // display: block;
          line-height: 0px;
        }
      }
    }

    .del {
      border-top: 1px solid #6d6d6d;
      font-size: 11px;
      height: 22px;
      line-height: 22px;
      text-align: center;
      color: #2e7cd4;
      // background-color: #f2f2f2;
      cursor: pointer;
    }
  }
}

.table_btn {
  cursor: pointer;
}
</style>
